import { useMemo } from "react";
import Avatar from "../Avatar";
import Button from "../Button";
import Icon from "../icons/Icon";
import Sheet from "../Sheet";
import { farbNummern } from "../../spieler";
import "./PunkteDialog.css";

/** Punktestand von Hand korrigieren (Host). Der Verlauf bleibt, wie er ist. */
export function PunkteDialog({ players, setPlayers, onClose }) {
  const name = (p, i) => p.name.trim() || `Spieler ${i + 1}`;
  const namenSchluessel = players.map(name).join("\n");
  const farbe = useMemo(() => farbNummern(namenSchluessel.split("\n")), [namenSchluessel]);
  const aendern = (i, delta) =>
    setPlayers((prev) => prev.map((pl, idx) => (idx === i ? { ...pl, score: Math.max(0, pl.score + delta) } : pl)));

  return (
    <Sheet
      titel="Punkte anpassen"
      mitX
      onClose={onClose}
      fuss={
        <Button variant="haupt" onClick={onClose}>
          Fertig
        </Button>
      }
    >
      <p className="sheet-hinweis">Korrigiert nur den Stand – der Verlauf bleibt, wie er ist.</p>
      {players.map((p, i) => (
        <div key={i} className="stepper-zeile">
          <Avatar name={name(p, i)} farbe={farbe(name(p, i))} />
          <span className="stepper-name">{name(p, i)}</span>
          <span className="stepper">
            <button type="button" onClick={() => aendern(i, -1)} disabled={p.score === 0} aria-label={`${name(p, i)} minus 1`}>
              <Icon name="minus" />
            </button>
            <b aria-label={`${name(p, i)}: ${p.score} Punkte`}>{p.score}</b>
            <button type="button" className="plus" onClick={() => aendern(i, +1)} aria-label={`${name(p, i)} plus 1`}>
              <Icon name="plus" />
            </button>
          </span>
        </div>
      ))}
    </Sheet>
  );
}

export default PunkteDialog;
